import defineService from "./defineService";

const getTeamWithToken = defineService('get', 'api/v1/team/:team/:token');

export async function loadJoinTeamData(team, token) {
  return getTeamWithToken(team, token);
}



// WEBPACK FOOTER //
// ./src/services/join.js